import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomSwitch from "../../../../components/CustomSwitch";
import { GetAntrepoInListResponse } from "../../../../models/response/antrepoIn/GetAntrepoInListResponse";
import { storeActivityIndicator } from "../../../../redux/reducers/authSlice";
import { AntrepoInService } from "../../../../services/AntrepoInService";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { InOutListModel, InOutListModelDetailModel, InOutListModelServiceModel, ResponseModel } from "../CalculateList";
import toast from "react-hot-toast";
import { CompanyService } from "../../../../services/CompanyService";
import { Helpers } from "../../../../helpers/Helpers";
import { AntrepoOutService } from "../../../../services/AntrepoOutService";
import { GetAntrepoOutListResponse } from "../../../../models/response/antrepoOut/GetAntrepoOutListResponse";
import { GetAntrepoInByIdResponse } from "../../../../models/response/antrepoIn/GetAntrepoInByIdResponse";
import { AgreementService } from "../../../../services/AgreementService";
import { GetAgreementListResponse, GetAgreementListResponseDaum } from "../../../../models/response/agreement/GetAgreementListResponse";
import { GetAgreementByIdResponse } from "../../../../models/response/agreement/GetAgreementByIdResponse";
import { PriceService } from "../../../../services/PriceService";
import { GetPriceListResponse } from "../../../../models/response/price/GetPriceListResponse";
import { CustomMultiSelectModel } from "../../../../components/CustomMultiSelect";
import moment from "moment";

interface Props {
    setInOutList: React.Dispatch<React.SetStateAction<InOutListModel[]>>
    setSelectedCurrentCompany: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    setInOutDetailList: React.Dispatch<React.SetStateAction<InOutListModelDetailModel[]>>
    selectedCurrentCompany: CustomSingleSelectModel | undefined
    isOut: boolean
    setIsOut: React.Dispatch<React.SetStateAction<boolean>>
    setInOutServiceList: React.Dispatch<React.SetStateAction<InOutListModelServiceModel[]>>
    isIn: boolean
    setIsIn: React.Dispatch<React.SetStateAction<boolean>>
    setSelectedAgreements: React.Dispatch<React.SetStateAction<CustomMultiSelectModel[]>>
    setResponseList: React.Dispatch<React.SetStateAction<ResponseModel[]>>
    setSelectedDate: React.Dispatch<React.SetStateAction<string>>
    setAgreementList: React.Dispatch<React.SetStateAction<CustomSingleSelectModel[]>>
    setCurrencyTypes: React.Dispatch<React.SetStateAction<CustomSingleSelectModel[]>>
    setSelectedCurrencyType: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    onAgreementChange: (selectedValues: CustomMultiSelectModel[]) => Promise<void>
}

const GeneralInformation = ({
    setInOutList,
    setSelectedCurrentCompany,
    setInOutDetailList,
    selectedCurrentCompany,
    isOut,
    setIsOut,
    setInOutServiceList,
    isIn,
    setIsIn,
    setSelectedAgreements,
    setResponseList,
    setSelectedDate,
    setAgreementList,
    setCurrencyTypes,
    setSelectedCurrencyType,
    onAgreementChange
}: Props) => {
    const dispatch = useDispatch();

    const onCompanySelected = async (_selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            if (!_selectedValue) {
                setSelectedCurrentCompany(undefined);
                setInOutList([]);
                setResponseList([]);
                setInOutDetailList([]);
                setInOutServiceList([]);

                return;
            }

            dispatch(storeActivityIndicator(true));
            setSelectedCurrentCompany(_selectedValue);

            if (isIn) {
                var response: GetAntrepoInListResponse = await AntrepoInService.getAntrepoInList(_selectedValue);

                if (!response.isSuccess) {
                    toast.error(response.message)
                    return;
                }

                // Sadece stoktakilerdi ardiye kısımını bozduğu için kapatıldı.
                for (var i = 0; i < response.data.length; i++) {
                    response.data[i].antrepoInVehicleProducts = response.data[i].antrepoInVehicleProducts.filter(x => x.stockArea > 0 || x.stockGrossWeight > 0 || x.stockPotQuantity > 0 || x.stockVolume > 0);
                }

                response.data = response.data.filter(x => x.antrepoInVehicleProducts.length > 0);

                for (var i = 0; i < response.data.length; i++) {
                    response.data[i].antrepoInVehicles = response.data[i].antrepoInVehicles.filter(x => !x.willNotBeInvoiced && (Helpers.isEmpty(x.lastInvoicedDate) || x.lastInvoicedDate?.split('T')[0] != moment().format('YYYY-MM-DD')));
                }

                response.data = response.data.filter(x => x.antrepoInVehicles.length > 0);

                for (var i = 0; i < response.data.length; i++) {
                    response.data[i].antrepoInVehicleServices = response.data[i].antrepoInVehicleServices.filter(x => !x.willNotBeInvoiced);
                }

                response.data = response.data.filter(x => x.antrepoInVehicleServices.length > 0);

                response.data = response.data.filter(x => x.isRedrese == false);

                setInOutList(response.data.map(function (x) {
                    var o: InOutListModel = {
                        ledgerNo: x.ledgerNo,
                        antrepoDeclarationNo: x.antrepoDeclarationNo,
                        antrepoDeclarationDateStr: x.antrepoDeclarationDateStr,
                        isSelected: false,
                        entityId: x.antrepoInId,
                        parentId: undefined,
                        details: x.antrepoInVehicleProducts.map(function (x2) {
                            var lastInvoicedDate = x.antrepoInVehicles.find(a => a.antrepoInVehicleId == x2.antrepoInVehicleId)?.lastInvoicedDate;

                            var o2: InOutListModelDetailModel = {
                                ledgerNo: x.ledgerNo,
                                entityId: x2.antrepoInVehicleProductId,
                                parentId: x.antrepoInId,
                                productKindName: x2.productKindName,
                                productKindId: x2.productKindId,
                                potTypeName: x2.potTypeName,
                                potTypeId: x2.potTypeId,
                                isSelected: false,
                                stockArea: x2.stockArea.toString(),
                                stockGrossWeight: x2.stockGrossWeight.toString(),
                                stockPotQuantity: x2.stockPotQuantity.toString(),
                                stockVolume: x2.stockVolume.toString(),
                                processArea: x2.stockArea.toString(),
                                processGrossWeight: x2.stockGrossWeight.toString(),
                                processPotQuantity: x2.stockPotQuantity.toString(),
                                processVolume: x2.stockVolume.toString(),
                                startDate: lastInvoicedDate ? lastInvoicedDate : x.antrepoInVehicles.find(a => a.antrepoInVehicleId == x2.antrepoInVehicleId)?.antrepoEnteranceDate,
                                endDate: undefined,
                                antrepoDeclarationNo: x.antrepoDeclarationNo,
                                palletCount: x2.palletCount,
                                containerCount: x.antrepoInVehicles.filter(x => !Helpers.isEmpty(x.containerNo)).length.toString(),
                                vehicleCount: x.antrepoInVehicles.length.toString(),
                                gTipId: x2.gTipId,
                                antrepoInVehicleProductId: x2.antrepoInVehicleProductId,
                                antrepoInVehicleId: x2.antrepoInVehicleId,
                                antrepoOutVehicleId: undefined
                            }

                            return o2;
                        }),
                        services: x.antrepoInVehicleServices.filter(x => Helpers.isEmpty(x.lastInvoicedDate)).map(function (x2) {
                            var o2: InOutListModelServiceModel = {
                                ledgerNo: x.ledgerNo,
                                entityId: x2.antrepoInVehicleServiceId,
                                parentId: x.antrepoInId,
                                multiplierName: x2.multiplierName,
                                quantity: x2.quantity?.toString(),
                                serviceName: x2.serviceName,
                                isSelected: false,
                                serviceId: x2.serviceId,
                                antrepoDeclarationNo: x.antrepoDeclarationNo,
                                multiplierId: x2.multiplierId,
                                needQuantity: x2.needQuantity,
                                antrepoInVehicleServiceId: x2.antrepoInVehicleServiceId,
                                antrepoOutVehicleServiceId: undefined
                            }

                            return o2;
                        })
                    }

                    return o;
                }))
            }
            else {
                var response2: GetAntrepoOutListResponse = await AntrepoOutService.getAntrepoOutList(_selectedValue);

                if (!response2.isSuccess) {
                    toast.error(response2.message)
                    return;
                }

                for (var i = 0; i < response2.data.length; i++) {
                    response2.data[i].antrepoOutVehicles = response2.data[i].antrepoOutVehicles.filter(x => !x.willNotBeInvoiced);
                }

                response2.data = response2.data.filter(x => x.antrepoOutVehicles.length > 0);

                for (var i = 0; i < response2.data.length; i++) {
                    response2.data[i].antrepoOutVehicleServices = response2.data[i].antrepoOutVehicleServices.filter(x => !x.willNotBeInvoiced);
                }

                response2.data = response2.data.filter(x => x.antrepoOutVehicleServices.length > 0);

                var _list: InOutListModel[] = response2.data.map(function (x) {
                    var o: InOutListModel = {
                        ledgerNo: x.ledgerNo,
                        antrepoDeclarationNo: x.antrepoDeclarationNo,
                        antrepoDeclarationDateStr: x.antrepoDeclarationDateStr,
                        isSelected: false,
                        entityId: x.antrepoOutId,
                        parentId: x.antrepoInId,
                        details: x.antrepoOutVehicleProducts.map(function (x2) {
                            var lastInvoicedDate = x.antrepoOutVehicles.find(a => a.antrepoOutVehicleId == x2.antrepoOutVehicleId)?.lastInvoicedDate;

                            var o2: InOutListModelDetailModel = {
                                ledgerNo: x.ledgerNo,
                                entityId: x2.antrepoOutVehicleProductId,
                                parentId: x.antrepoOutId,
                                productKindName: x2.productKindName,
                                productKindId: x2.productKindId,
                                potTypeName: x2.potTypeName,
                                potTypeId: x2.potTypeId,
                                isSelected: false,
                                stockArea: x2.area.toString(),
                                stockGrossWeight: x2.grossWeight.toString(),
                                stockPotQuantity: x2.potQuantity.toString(),
                                stockVolume: x2.volume.toString(),
                                processArea: x2.area.toString(),
                                processGrossWeight: x2.grossWeight.toString(),
                                processPotQuantity: x2.potQuantity.toString(),
                                processVolume: x2.volume.toString(),
                                startDate: lastInvoicedDate ? lastInvoicedDate : undefined,
                                endDate: x.antrepoOutVehicles.find(a => a.antrepoOutVehicleId == x2.antrepoOutVehicleId)?.antrepoExitDate,
                                antrepoDeclarationNo: x.antrepoDeclarationNo,
                                palletCount: x2.palletCount,
                                containerCount: x.antrepoOutVehicles.filter(x => !Helpers.isEmpty(x.containerNo)).length.toString(),
                                vehicleCount: x.antrepoOutVehicles.length.toString(),
                                gTipId: x2.gTipId,
                                antrepoInVehicleProductId: x2.antrepoInVehicleProductId,
                                antrepoInVehicleId: undefined,
                                antrepoOutVehicleId: x2.antrepoOutVehicleId
                            }

                            return o2;
                        }),
                        services: x.antrepoOutVehicleServices.filter(x => Helpers.isEmpty(x.lastInvoicedDate)).map(function (x2) {
                            var o2: InOutListModelServiceModel = {
                                ledgerNo: x.ledgerNo,
                                entityId: x2.antrepoOutVehicleServiceId,
                                parentId: x.antrepoOutId,
                                multiplierName: x2.multiplierName,
                                quantity: x2.quantity?.toString(),
                                serviceName: x2.serviceName,
                                isSelected: false,
                                serviceId: x2.serviceId,
                                antrepoDeclarationNo: x.antrepoDeclarationNo,
                                multiplierId: x2.multiplierId,
                                needQuantity: x2.needQuantity,
                                antrepoInVehicleServiceId: undefined,
                                antrepoOutVehicleServiceId: x2.antrepoOutVehicleServiceId
                            }

                            return o2;
                        })
                    }

                    return o;
                })

                // Çıkış işaretlendiğinde ek hizmetler'in giriş olarak işaretlenenleri girişten okundu.
                if (_list.length > 0) {
                    var antrepoInIds = [...new Set(response2.data.map(x => x.antrepoInId).filter(x => x && !Helpers.isEmpty(x)))];

                    for (var i = 0; i < antrepoInIds.length; i++) {
                        var response3: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(antrepoInIds[i]);

                        if (!response3.isSuccess) {
                            toast.error(response3.message)
                            return;
                        }

                        response3.data.antrepoInVehicleServices.filter(x => x.isAntrepoIn && Helpers.isEmpty(x.lastInvoicedDate)).forEach((service) => {
                            var antrepoOut = _list.find(x => x.parentId == antrepoInIds[i]);

                            if (antrepoOut) {
                                _list.find(x => x.parentId == antrepoInIds[i])?.services.push({
                                    ledgerNo: antrepoOut.ledgerNo,
                                    entityId: antrepoOut.entityId,
                                    parentId: antrepoOut.parentId ?? '',
                                    multiplierName: service.multiplierName ?? '',
                                    quantity: service.quantity?.toString() ?? '0',
                                    serviceName: service.serviceName,
                                    isSelected: false,
                                    serviceId: service.serviceId ?? '',
                                    antrepoDeclarationNo: antrepoOut.antrepoDeclarationNo,
                                    multiplierId: service.multiplierId ?? '',
                                    needQuantity: service.needQuantity ?? false,
                                    antrepoInVehicleServiceId: service.antrepoInVehicleServiceId,
                                    antrepoOutVehicleServiceId: undefined
                                })
                            }
                        })
                    }
                }

                for (var i = 0; i < _list.length; i++) {
                    var response3: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(_list[i].parentId + '');

                    if (!response3.isSuccess) {
                        toast.error(response3.message)
                        return;
                    }

                    for (var k = 0; k < _list[i].details.length; k++) {
                        var item = _list[i].details[k];
                        var inProducts = response3.data.antrepoInVehicleProducts.filter(x => x.gTipId == item.gTipId);

                        item.stockPotQuantity = Helpers.sumOfNumbers(inProducts.map(x => Helpers.toNumber(x.stockPotQuantity))).toString();
                        item.stockGrossWeight = Helpers.sumOfNumbers(inProducts.map(x => Helpers.toNumber(x.stockGrossWeight))).toString();
                        item.stockArea = Helpers.sumOfNumbers(inProducts.map(x => Helpers.toNumber(x.stockArea))).toString();
                        item.stockVolume = Helpers.sumOfNumbers(inProducts.map(x => Helpers.toNumber(x.stockVolume))).toString();
                        var antrepoInVehicleProduct = inProducts.find(x => x.antrepoInVehicleProductId == item.antrepoInVehicleProductId);

                        if (antrepoInVehicleProduct) {
                            var antrepoInVehicle = response3.data.antrepoInVehicles.find(x => x.antrepoInVehicleId == antrepoInVehicleProduct?.antrepoInVehicleId);

                            if (antrepoInVehicle) {
                                item.startDate = !Helpers.isEmpty(item.startDate) ? item.startDate : antrepoInVehicle.lastInvoicedDate ? antrepoInVehicle.lastInvoicedDate : antrepoInVehicle.antrepoEnteranceDate;
                            }
                        }

                    }
                }

                // for (var i = 0; i < _list.length; i++) {
                //     var response3: GetAntrepoInByIdResponse = await AntrepoInService.getAntrepoInById(_list[i].parentId + '', false);

                //     if (!response3.isSuccess) {
                //         toast.error(response3.message)
                //         return;
                //     }

                //     for (var k = 0; k < _list[i].details.length; k++) {
                //         var item = _list[i].details[k];

                //         item.stockArea = "0";
                //         item.stockGrossWeight = "0";
                //         item.stockPotQuantity = "0";
                //         item.stockVolume = "0";

                //         if (isIn) {
                //             item.processArea = "0";
                //             item.processGrossWeight = "0";
                //             item.processPotQuantity = "0";
                //             item.processVolume = "0";
                //         }

                //         if (k == 0) {
                //             var _stockArea = Helpers.sumOfNumbers(response3.data.antrepoInVehicleProducts.filter(x => x.productKindId == item.productKindId && x.potTypeId == item.potTypeId).map(x => Helpers.toNumber(x.stockArea))).toString();
                //             item.stockArea = (Helpers.toNumber(item.stockArea) + Helpers.toNumber(_stockArea)).toString();

                //             if (isIn)
                //                 item.processArea = item.stockArea;

                //             var _stockGrossWeight = Helpers.sumOfNumbers(response3.data.antrepoInVehicleProducts.filter(x => x.productKindId == item.productKindId && x.potTypeId == item.potTypeId).map(x => Helpers.toNumber(x.stockGrossWeight))).toString();
                //             item.stockGrossWeight = (Helpers.toNumber(item.stockGrossWeight) + Helpers.toNumber(_stockGrossWeight)).toString();

                //             if (isIn)
                //                 item.processGrossWeight = item.stockGrossWeight;

                //             var _stockPotQuantity = Helpers.sumOfNumbers(response3.data.antrepoInVehicleProducts.filter(x => x.productKindId == item.productKindId && x.potTypeId == item.potTypeId).map(x => Helpers.toNumber(x.stockPotQuantity))).toString();
                //             item.stockPotQuantity = (Helpers.toNumber(item.stockPotQuantity) + Helpers.toNumber(_stockPotQuantity)).toString();

                //             if (isIn)
                //                 item.processPotQuantity = item.stockPotQuantity;

                //             var _stockVolume = Helpers.sumOfNumbers(response3.data.antrepoInVehicleProducts.filter(x => x.productKindId == item.productKindId && x.potTypeId == item.potTypeId).map(x => Helpers.toNumber(x.stockVolume))).toString();
                //             item.stockVolume = (Helpers.toNumber(item.stockVolume) + Helpers.toNumber(_stockVolume)).toString();

                //             if (isIn)
                //                 item.processVolume = item.stockVolume;
                //         }
                //     }
                // }

                setInOutList(_list)
            }

            var response5: GetPriceListResponse = await PriceService.getPriceList(true, undefined, undefined, undefined, undefined);

            if (!response5.isSuccess) {
                toast.error(response5.message)
                return;
            }

            // Anlaşma listesinde tek anlaşma var ise o seçili gelir
            var response4: GetAgreementListResponse = await AgreementService.getAgreementList(true, undefined, undefined, undefined, undefined, _selectedValue.value);

            if (!response4.isSuccess) {
                toast.error(response4.message)
                return;
            }



            if (response4.data.length == 1) {
                onAgreementChange([{ label: response4.data[0].refNo + ' - ' + response4.data[0].name, value: response4.data[0].agreementId, additionalValue1: response4.data[0].refNo }]);
            }

            var tempAgreementList: CustomSingleSelectModel[] = response4.data.map(function (x) {
                return { label: x.refNo + ' - ' + x.name, value: x.agreementId, additionalValue1: x.refNo }
            })

            var tempPriceList: CustomSingleSelectModel[] = response5.data.map(function (x) {
                return { label: x.refNo + ' - ' + x.name, value: x.priceId, additionalValue1: x.refNo }
            })

            setAgreementList([...tempAgreementList, ...tempPriceList]);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div>
            <KTCard className="ebbe-card">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Genel Bilgiler</h4>

                    <div className="row">
                        <div className="col-md-12">
                            <Box gap="20px" flexDirection="row">
                                <Box justifyContent="center" flexGrow={1}>
                                    <label htmlFor="exampleFormControlInput1" className="form-label required">Firma</label>

                                    <CustomSingleSelect
                                        selectedValue={selectedCurrentCompany}
                                        onChange={onCompanySelected}
                                        onMenuOpen={[
                                            () => CompanyService.getCompanyList({ isCustomer: true }),
                                            () => CompanyService.getCompanyList({ isAgency: true }),
                                            () => CompanyService.getCompanyList({ isSupplier: true }),
                                        ]}
                                        labelName='name'
                                        valueName='companyId'
                                    />
                                </Box>

                                <Box justifyContent="center">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Ardiye Kesilecekler</label>
                                    <CustomSwitch isActive={isIn} setIsActive={() => {
                                        setIsIn(!isIn);
                                        setIsOut(!isOut);
                                        setInOutDetailList([]);
                                        setInOutServiceList([]);
                                        setSelectedAgreements([]);
                                        setResponseList([]);
                                        setSelectedDate(moment().format('YYYY-MM-DD'));
                                        setInOutList([]);
                                        setResponseList([]);
                                        setSelectedCurrentCompany(undefined);
                                    }} />
                                </Box>

                                <Box justifyContent="center">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">Çıkış Olan</label>
                                    <CustomSwitch isActive={isOut} setIsActive={() => {
                                        setIsIn(!isIn);
                                        setIsOut(!isOut);
                                        setInOutDetailList([]);
                                        setInOutServiceList([]);
                                        setSelectedAgreements([]);
                                        setResponseList([]);
                                        setSelectedDate('');
                                        setInOutList([]);
                                        setResponseList([]);
                                        setSelectedCurrentCompany(undefined);
                                    }} />
                                </Box>
                            </Box>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default GeneralInformation;